var render, staticRenderFns
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\space\\tops\\tops-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f0b9ce8')) {
      api.createRecord('8f0b9ce8', component.options)
    } else {
      api.reload('8f0b9ce8', component.options)
    }
    
  }
}
component.options.__file = "src/packages/main/src/page/chatPage/content/index.vue"
export default component.exports